import { EDatasetsNames } from 'Common/consts';
import { useSelectedDatasetName } from 'Datasets/store';
export const useIsSelectedDatasetUkb500k = () => {
    const selectedDatasetName = useSelectedDatasetName();
    return [
        EDatasetsNames.INTERNAL_500K,
        EDatasetsNames.PUBLIC_500K,
    ].includes(selectedDatasetName);
};
